const CATEGORIES_ACTION_TYPES = {
    // SET_CATEGORIES: 'category/SET_CATEGORIES',
    FETCH_CATEGORIES_START: 'FETCH_CATEGORIES_START',
    FETCH_CATEGORIES_SUCCESS: 'FETCH_CATEGORIES_SUCCESS',
    FETCH_CATEGORIES_FAILED: 'FETCH_CATEGORIES_FAILED',
};

export default CATEGORIES_ACTION_TYPES
  
